import AbstractAsyncTablePage from '../abstract-async-table-page';
import TireWarrantySearchForm from '../../components/tire-warranty/tire-warranty-search-form';
import Table from '../../components/shared/table';
import TireWarrantyData from '../../model/tire-warranty-data';
import { formatDate } from '../../helpers/utils';
import HTMLTemplateHelper from '../../helpers/html-template-helper';
import MessageHelper from '../../helpers/message-helper';

export default class TireWarrantySubmittedPage extends AbstractAsyncTablePage {

  protected readonly searchForm: TireWarrantySearchForm;
  protected readonly table: Table;
  protected readonly tableColumnConfiguration: DataTables.ColumnDefsSettings[] = [
    { targets: 0, data: 'warrantyId' },
    {
      targets: 1,
      data: (data: TireWarrantyData, type: string): string | number => {
        if (type === 'sort') {
          return data.dateOfSubmission;
        }
        return formatDate(new Date(data.dateOfSubmission));
      },
    },
    { targets: 2, data: 'customerContact' },
    { targets: 3, data: 'reference' },
    { targets: 4, data: 'status' },
    { targets: 5, data: 'reason' },
    { targets: 6, data: (data: TireWarrantyData): string | null => data.vehicle?.vin ?? null },
    { targets: 7, data: (data: TireWarrantyData): string | null => data.vehicle?.licensePlate ?? null },
    { targets: 8, data: 'invoiceId' },
    { targets: 9, data: 'creditId' },
    { targets: 10, data: 'totalCreditNote' },
    {
      targets: 11,
      data: (data: TireWarrantyData): string => HTMLTemplateHelper.createLinkButton({
        text: MessageHelper.getMessage('common.open'),
        buttonClass: '-primary -compact',
        href: `${window.ACC.config.encodedContextPath}/tireWarranty/submitted/${data.warrantyId}`,
      }).outerHTML,
    },
  ];

  constructor(private readonly body: JQuery) {
    super();
    this.searchForm = new TireWarrantySearchForm(body.find('.js-filters') as JQuery<HTMLFormElement>);
    this.table = new Table(body.find('.js-table'), this.tableColumnConfiguration);
    this.bindAsyncData();
  }
}
